import IEligibilityClient from './IEligibilityClient';
import {
  EligibilityClientDependencies,
  EligibilityGraphQLResponse
} from './types';
import { EligibilityRuleInput } from '../../../services/eligibilityService/types';
import IGraphQLService from '../../../services/graphQLService/IGraphQLService';
import { internalLogger } from '../../../interface/v1/clientOsLogger';

const ELIGIBILITY_QUERY = `query Eligibility($public: Boolean!, $rules: [EligibilityItemInput!]!) {
  eligibility(public: $public, rules: $rules) {
    items {
      rulesSetId
      isEligible
      data {
        type
        value {
          key
          value
        }
      }
    }
  }
}`;

export default class EligibilityClient implements IEligibilityClient {
  private readonly graphQLService: IGraphQLService;

  constructor({ graphQLService }: EligibilityClientDependencies) {
    this.graphQLService = graphQLService;
  }

  async getEligibility(
    rules: EligibilityRuleInput[],
    isPublic = false
  ): Promise<EligibilityGraphQLResponse> {
    const client = this.graphQLService?.getClient?.();
    if (!client?.query) {
      internalLogger?.system?.s4({
        message: 'EligibilityClient: GraphQL client is not available.'
      });
      return;
    }

    const response = await client.query<
      EligibilityGraphQLResponse,
      Record<string, unknown>
    >(
      ELIGIBILITY_QUERY,
      { public: isPublic, rules },
      { fetchPolicy: 'no-cache' }
    );

    if (!response?.data?.eligibility) {
      const message =
        response?.errors?.map((error) => error.message).join('; ') ||
        'Unknown error';

      throw new Error(`Failed to fetch eligibility: ${message}`);
    }

    return response?.data;
  }
}
